export class EnvironmentUtils {
    public static shouldShowDebugDialogs(): boolean {
        return false;
    }

    // TODO review before merging, env vars doesnt work when deployed in dev env 
    /**
     * Check if debug dialogs should be shown in the application
     * This is controlled by the SHOW_DEBUG_INAPP_DIALOGS environment variable
     * @returns boolean indicating if debug dialogs should be shown
     */
    // public static shouldShowDebugDialogs(): boolean {
    //     // Check for environment variable in different contexts
    //     const envValue = import.meta.env.VITE_SHOW_DEBUG_INAPP_DIALOGS ||
    //         window.__ENV__?.SHOW_DEBUG_INAPP_DIALOGS;

    //     // Convert string to boolean - only 'true' (case insensitive) returns true
    //     return envValue?.toString().toLowerCase() === 'true';
    // }
}

// Extend Window interface to include our custom environment variables
// declare global {
//     interface Window {
//         __ENV__?: {
//             SHOW_DEBUG_INAPP_DIALOGS?: string;
//         };
//     }
// } 